module.exports = __webpack_public_path__ + "img/moneylion-L2-1.3c32aa34.jpg";